export function debounce(func, wait) {

  let timeout;
  return function(...args) {

    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

  };
}